// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file questionnaire/v2/questionnaire.proto (package questionnaire.v2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { QuestionnaireStatus } from "../common/v1/questionnaire_status_pb";
import { file_questionnaire_common_v1_questionnaire_status } from "../common/v1/questionnaire_status_pb";
import type { ManualQuestionStatus, Questionnaire, QuestionnaireType } from "./model_pb";
import { file_questionnaire_v2_model } from "./model_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file questionnaire/v2/questionnaire.proto.
 */
export const file_questionnaire_v2_questionnaire: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_questionnaire_common_v1_questionnaire_status, file_questionnaire_v2_model]);

/**
 * @generated from message questionnaire.v2.GetQuestionnaireArtifactPreviewUrlRequest
 */
export type GetQuestionnaireArtifactPreviewUrlRequest = Message<"questionnaire.v2.GetQuestionnaireArtifactPreviewUrlRequest"> & {
  /**
   * @generated from field: string questionnaire_artifact_id = 1;
   */
  questionnaireArtifactId: string;

  /**
   * @generated from field: string filename = 2;
   */
  filename: string;
};

/**
 * Describes the message questionnaire.v2.GetQuestionnaireArtifactPreviewUrlRequest.
 * Use `create(GetQuestionnaireArtifactPreviewUrlRequestSchema)` to create a new message.
 */
export const GetQuestionnaireArtifactPreviewUrlRequestSchema: GenMessage<GetQuestionnaireArtifactPreviewUrlRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 0);

/**
 * @generated from message questionnaire.v2.SmartEvidenceReviewSetting
 */
export type SmartEvidenceReviewSetting = Message<"questionnaire.v2.SmartEvidenceReviewSetting"> & {
  /**
   * @generated from field: bool require_comment_on_accept = 1;
   */
  requireCommentOnAccept: boolean;

  /**
   * @generated from field: bool require_comment_on_reject = 2;
   */
  requireCommentOnReject: boolean;
};

/**
 * Describes the message questionnaire.v2.SmartEvidenceReviewSetting.
 * Use `create(SmartEvidenceReviewSettingSchema)` to create a new message.
 */
export const SmartEvidenceReviewSettingSchema: GenMessage<SmartEvidenceReviewSetting> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 1);

/**
 * @generated from message questionnaire.v2.GetSmartEvidenceReviewSettingRequest
 */
export type GetSmartEvidenceReviewSettingRequest = Message<"questionnaire.v2.GetSmartEvidenceReviewSettingRequest"> & {
};

/**
 * Describes the message questionnaire.v2.GetSmartEvidenceReviewSettingRequest.
 * Use `create(GetSmartEvidenceReviewSettingRequestSchema)` to create a new message.
 */
export const GetSmartEvidenceReviewSettingRequestSchema: GenMessage<GetSmartEvidenceReviewSettingRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 2);

/**
 * @generated from message questionnaire.v2.GetSmartEvidenceReviewSettingResponse
 */
export type GetSmartEvidenceReviewSettingResponse = Message<"questionnaire.v2.GetSmartEvidenceReviewSettingResponse"> & {
  /**
   * @generated from field: questionnaire.v2.SmartEvidenceReviewSetting setting = 1;
   */
  setting?: SmartEvidenceReviewSetting;
};

/**
 * Describes the message questionnaire.v2.GetSmartEvidenceReviewSettingResponse.
 * Use `create(GetSmartEvidenceReviewSettingResponseSchema)` to create a new message.
 */
export const GetSmartEvidenceReviewSettingResponseSchema: GenMessage<GetSmartEvidenceReviewSettingResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 3);

/**
 * @generated from message questionnaire.v2.SetSmartEvidenceReviewSettingRequest
 */
export type SetSmartEvidenceReviewSettingRequest = Message<"questionnaire.v2.SetSmartEvidenceReviewSettingRequest"> & {
  /**
   * @generated from field: bool require_comment_on_accept = 1;
   */
  requireCommentOnAccept: boolean;

  /**
   * @generated from field: bool require_comment_on_reject = 2;
   */
  requireCommentOnReject: boolean;
};

/**
 * Describes the message questionnaire.v2.SetSmartEvidenceReviewSettingRequest.
 * Use `create(SetSmartEvidenceReviewSettingRequestSchema)` to create a new message.
 */
export const SetSmartEvidenceReviewSettingRequestSchema: GenMessage<SetSmartEvidenceReviewSettingRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 4);

/**
 * @generated from message questionnaire.v2.SetSmartEvidenceReviewSettingResponse
 */
export type SetSmartEvidenceReviewSettingResponse = Message<"questionnaire.v2.SetSmartEvidenceReviewSettingResponse"> & {
};

/**
 * Describes the message questionnaire.v2.SetSmartEvidenceReviewSettingResponse.
 * Use `create(SetSmartEvidenceReviewSettingResponseSchema)` to create a new message.
 */
export const SetSmartEvidenceReviewSettingResponseSchema: GenMessage<SetSmartEvidenceReviewSettingResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 5);

/**
 * @generated from message questionnaire.v2.GetQuestionnaireArtifactPreviewUrlResponse
 */
export type GetQuestionnaireArtifactPreviewUrlResponse = Message<"questionnaire.v2.GetQuestionnaireArtifactPreviewUrlResponse"> & {
  /**
   * @generated from field: string preview_url = 1;
   */
  previewUrl: string;
};

/**
 * Describes the message questionnaire.v2.GetQuestionnaireArtifactPreviewUrlResponse.
 * Use `create(GetQuestionnaireArtifactPreviewUrlResponseSchema)` to create a new message.
 */
export const GetQuestionnaireArtifactPreviewUrlResponseSchema: GenMessage<GetQuestionnaireArtifactPreviewUrlResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 6);

/**
 * @generated from message questionnaire.v2.FinalizeQuestionnaireRequest
 */
export type FinalizeQuestionnaireRequest = Message<"questionnaire.v2.FinalizeQuestionnaireRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bool assessment_finished = 2;
   */
  assessmentFinished: boolean;
};

/**
 * Describes the message questionnaire.v2.FinalizeQuestionnaireRequest.
 * Use `create(FinalizeQuestionnaireRequestSchema)` to create a new message.
 */
export const FinalizeQuestionnaireRequestSchema: GenMessage<FinalizeQuestionnaireRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 7);

/**
 * @generated from message questionnaire.v2.FinalizeQuestionnaireResponse
 */
export type FinalizeQuestionnaireResponse = Message<"questionnaire.v2.FinalizeQuestionnaireResponse"> & {
};

/**
 * Describes the message questionnaire.v2.FinalizeQuestionnaireResponse.
 * Use `create(FinalizeQuestionnaireResponseSchema)` to create a new message.
 */
export const FinalizeQuestionnaireResponseSchema: GenMessage<FinalizeQuestionnaireResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 8);

/**
 * @generated from message questionnaire.v2.SubmitManualQuestionnaireRequest
 */
export type SubmitManualQuestionnaireRequest = Message<"questionnaire.v2.SubmitManualQuestionnaireRequest"> & {
  /**
   * @generated from field: string questionnaire_id = 1;
   */
  questionnaireId: string;
};

/**
 * Describes the message questionnaire.v2.SubmitManualQuestionnaireRequest.
 * Use `create(SubmitManualQuestionnaireRequestSchema)` to create a new message.
 */
export const SubmitManualQuestionnaireRequestSchema: GenMessage<SubmitManualQuestionnaireRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 9);

/**
 * @generated from message questionnaire.v2.SubmitManualQuestionnaireResponse
 */
export type SubmitManualQuestionnaireResponse = Message<"questionnaire.v2.SubmitManualQuestionnaireResponse"> & {
};

/**
 * Describes the message questionnaire.v2.SubmitManualQuestionnaireResponse.
 * Use `create(SubmitManualQuestionnaireResponseSchema)` to create a new message.
 */
export const SubmitManualQuestionnaireResponseSchema: GenMessage<SubmitManualQuestionnaireResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 10);

/**
 * @generated from message questionnaire.v2.UpdateManualQuestionRequest
 */
export type UpdateManualQuestionRequest = Message<"questionnaire.v2.UpdateManualQuestionRequest"> & {
  /**
   * @generated from field: string questionnaire_id = 1;
   */
  questionnaireId: string;

  /**
   * @generated from field: string question_id = 2;
   */
  questionId: string;

  /**
   * @generated from field: questionnaire.v2.ManualQuestionStatus status = 3;
   */
  status: ManualQuestionStatus;
};

/**
 * Describes the message questionnaire.v2.UpdateManualQuestionRequest.
 * Use `create(UpdateManualQuestionRequestSchema)` to create a new message.
 */
export const UpdateManualQuestionRequestSchema: GenMessage<UpdateManualQuestionRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 11);

/**
 * @generated from message questionnaire.v2.UpdateManualQuestionResponse
 */
export type UpdateManualQuestionResponse = Message<"questionnaire.v2.UpdateManualQuestionResponse"> & {
};

/**
 * Describes the message questionnaire.v2.UpdateManualQuestionResponse.
 * Use `create(UpdateManualQuestionResponseSchema)` to create a new message.
 */
export const UpdateManualQuestionResponseSchema: GenMessage<UpdateManualQuestionResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 12);

/**
 * @generated from message questionnaire.v2.SubmitManualQuestionnaireActivityRequest
 */
export type SubmitManualQuestionnaireActivityRequest = Message<"questionnaire.v2.SubmitManualQuestionnaireActivityRequest"> & {
  /**
   * @generated from field: string questionnaire_id = 1;
   */
  questionnaireId: string;

  /**
   * @generated from field: string question_id = 2;
   */
  questionId: string;

  /**
   * @generated from field: string comment = 3;
   */
  comment: string;

  /**
   * @generated from field: optional string liveblocks_thread_id = 4;
   */
  liveblocksThreadId?: string;
};

/**
 * Describes the message questionnaire.v2.SubmitManualQuestionnaireActivityRequest.
 * Use `create(SubmitManualQuestionnaireActivityRequestSchema)` to create a new message.
 */
export const SubmitManualQuestionnaireActivityRequestSchema: GenMessage<SubmitManualQuestionnaireActivityRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 13);

/**
 * @generated from message questionnaire.v2.SubmitManualQuestionnaireActivityResponse
 */
export type SubmitManualQuestionnaireActivityResponse = Message<"questionnaire.v2.SubmitManualQuestionnaireActivityResponse"> & {
};

/**
 * Describes the message questionnaire.v2.SubmitManualQuestionnaireActivityResponse.
 * Use `create(SubmitManualQuestionnaireActivityResponseSchema)` to create a new message.
 */
export const SubmitManualQuestionnaireActivityResponseSchema: GenMessage<SubmitManualQuestionnaireActivityResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 14);

/**
 * @generated from message questionnaire.v2.SubmitQuestionnaireActivityRequest
 */
export type SubmitQuestionnaireActivityRequest = Message<"questionnaire.v2.SubmitQuestionnaireActivityRequest"> & {
  /**
   * @generated from field: string questionnaire_id = 1;
   */
  questionnaireId: string;

  /**
   * @generated from field: string question_id = 2;
   */
  questionId: string;

  /**
   * @generated from field: string comment = 3;
   */
  comment: string;
};

/**
 * Describes the message questionnaire.v2.SubmitQuestionnaireActivityRequest.
 * Use `create(SubmitQuestionnaireActivityRequestSchema)` to create a new message.
 */
export const SubmitQuestionnaireActivityRequestSchema: GenMessage<SubmitQuestionnaireActivityRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 15);

/**
 * @generated from message questionnaire.v2.SubmitQuestionnaireActivityResponse
 */
export type SubmitQuestionnaireActivityResponse = Message<"questionnaire.v2.SubmitQuestionnaireActivityResponse"> & {
};

/**
 * Describes the message questionnaire.v2.SubmitQuestionnaireActivityResponse.
 * Use `create(SubmitQuestionnaireActivityResponseSchema)` to create a new message.
 */
export const SubmitQuestionnaireActivityResponseSchema: GenMessage<SubmitQuestionnaireActivityResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 16);

/**
 * @generated from message questionnaire.v2.SubmitRiskQuestionnaireThreadActivityRequest
 */
export type SubmitRiskQuestionnaireThreadActivityRequest = Message<"questionnaire.v2.SubmitRiskQuestionnaireThreadActivityRequest"> & {
  /**
   * @generated from field: string control_status_id = 1;
   */
  controlStatusId: string;

  /**
   * @generated from field: string comment = 2;
   */
  comment: string;

  /**
   * @generated from field: optional bool is_resolved = 3;
   */
  isResolved?: boolean;

  /**
   * Thread holding the comment's live copy; the comment field stays as our plain-text copy.
   *
   * @generated from field: optional string liveblocks_thread_id = 4;
   */
  liveblocksThreadId?: string;
};

/**
 * Describes the message questionnaire.v2.SubmitRiskQuestionnaireThreadActivityRequest.
 * Use `create(SubmitRiskQuestionnaireThreadActivityRequestSchema)` to create a new message.
 */
export const SubmitRiskQuestionnaireThreadActivityRequestSchema: GenMessage<SubmitRiskQuestionnaireThreadActivityRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 17);

/**
 * @generated from message questionnaire.v2.SubmitRiskQuestionnaireThreadActivityResponse
 */
export type SubmitRiskQuestionnaireThreadActivityResponse = Message<"questionnaire.v2.SubmitRiskQuestionnaireThreadActivityResponse"> & {
};

/**
 * Describes the message questionnaire.v2.SubmitRiskQuestionnaireThreadActivityResponse.
 * Use `create(SubmitRiskQuestionnaireThreadActivityResponseSchema)` to create a new message.
 */
export const SubmitRiskQuestionnaireThreadActivityResponseSchema: GenMessage<SubmitRiskQuestionnaireThreadActivityResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 18);

/**
 * Returns the comments room for the company, creating it on first use (ID tokens
 * can only enter existing rooms). The server owns the room-id derivation.
 *
 * @generated from message questionnaire.v2.GetPortalCommentsRoomRequest
 */
export type GetPortalCommentsRoomRequest = Message<"questionnaire.v2.GetPortalCommentsRoomRequest"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;
};

/**
 * Describes the message questionnaire.v2.GetPortalCommentsRoomRequest.
 * Use `create(GetPortalCommentsRoomRequestSchema)` to create a new message.
 */
export const GetPortalCommentsRoomRequestSchema: GenMessage<GetPortalCommentsRoomRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 19);

/**
 * @generated from message questionnaire.v2.GetPortalCommentsRoomResponse
 */
export type GetPortalCommentsRoomResponse = Message<"questionnaire.v2.GetPortalCommentsRoomResponse"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;
};

/**
 * Describes the message questionnaire.v2.GetPortalCommentsRoomResponse.
 * Use `create(GetPortalCommentsRoomResponseSchema)` to create a new message.
 */
export const GetPortalCommentsRoomResponseSchema: GenMessage<GetPortalCommentsRoomResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 20);

/**
 * @generated from message questionnaire.v2.GetRiskQuestionnaireRequest
 */
export type GetRiskQuestionnaireRequest = Message<"questionnaire.v2.GetRiskQuestionnaireRequest"> & {
  /**
   * @generated from field: string questionnaire_id = 1;
   */
  questionnaireId: string;
};

/**
 * Describes the message questionnaire.v2.GetRiskQuestionnaireRequest.
 * Use `create(GetRiskQuestionnaireRequestSchema)` to create a new message.
 */
export const GetRiskQuestionnaireRequestSchema: GenMessage<GetRiskQuestionnaireRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 21);

/**
 * @generated from message questionnaire.v2.GetRiskQuestionnaireResponse
 */
export type GetRiskQuestionnaireResponse = Message<"questionnaire.v2.GetRiskQuestionnaireResponse"> & {
  /**
   * @generated from field: questionnaire.v2.Questionnaire questionnaire = 1;
   */
  questionnaire?: Questionnaire;
};

/**
 * Describes the message questionnaire.v2.GetRiskQuestionnaireResponse.
 * Use `create(GetRiskQuestionnaireResponseSchema)` to create a new message.
 */
export const GetRiskQuestionnaireResponseSchema: GenMessage<GetRiskQuestionnaireResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 22);

/**
 * @generated from message questionnaire.v2.GetInfoQuestionnaireRequest
 */
export type GetInfoQuestionnaireRequest = Message<"questionnaire.v2.GetInfoQuestionnaireRequest"> & {
  /**
   * @generated from field: string questionnaire_id = 1;
   */
  questionnaireId: string;
};

/**
 * Describes the message questionnaire.v2.GetInfoQuestionnaireRequest.
 * Use `create(GetInfoQuestionnaireRequestSchema)` to create a new message.
 */
export const GetInfoQuestionnaireRequestSchema: GenMessage<GetInfoQuestionnaireRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 23);

/**
 * @generated from message questionnaire.v2.GetInfoQuestionnaireResponse
 */
export type GetInfoQuestionnaireResponse = Message<"questionnaire.v2.GetInfoQuestionnaireResponse"> & {
  /**
   * @generated from field: questionnaire.v2.Questionnaire questionnaire = 1;
   */
  questionnaire?: Questionnaire;
};

/**
 * Describes the message questionnaire.v2.GetInfoQuestionnaireResponse.
 * Use `create(GetInfoQuestionnaireResponseSchema)` to create a new message.
 */
export const GetInfoQuestionnaireResponseSchema: GenMessage<GetInfoQuestionnaireResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 24);

/**
 * @generated from message questionnaire.v2.ListQuestionnairesRequest
 */
export type ListQuestionnairesRequest = Message<"questionnaire.v2.ListQuestionnairesRequest"> & {
  /**
   * @generated from field: optional string company_id = 1;
   */
  companyId?: string;

  /**
   * @generated from field: optional string ongoing_assessment_id = 2;
   */
  ongoingAssessmentId?: string;
};

/**
 * Describes the message questionnaire.v2.ListQuestionnairesRequest.
 * Use `create(ListQuestionnairesRequestSchema)` to create a new message.
 */
export const ListQuestionnairesRequestSchema: GenMessage<ListQuestionnairesRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 25);

/**
 * @generated from message questionnaire.v2.ListQuestionnairesResponse
 */
export type ListQuestionnairesResponse = Message<"questionnaire.v2.ListQuestionnairesResponse"> & {
  /**
   * @generated from field: repeated questionnaire.v2.Questionnaire questionnaires = 1;
   */
  questionnaires: Questionnaire[];
};

/**
 * Describes the message questionnaire.v2.ListQuestionnairesResponse.
 * Use `create(ListQuestionnairesResponseSchema)` to create a new message.
 */
export const ListQuestionnairesResponseSchema: GenMessage<ListQuestionnairesResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 26);

/**
 * @generated from message questionnaire.v2.UpdateQuestionnaireRequest
 */
export type UpdateQuestionnaireRequest = Message<"questionnaire.v2.UpdateQuestionnaireRequest"> & {
  /**
   * @generated from field: string questionnaire_id = 1;
   */
  questionnaireId: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional questionnaire.common.v1.QuestionnaireStatus status = 4;
   */
  status?: QuestionnaireStatus;

  /**
   * @generated from field: optional google.protobuf.Timestamp due_date = 5;
   */
  dueDate?: Timestamp;
};

/**
 * Describes the message questionnaire.v2.UpdateQuestionnaireRequest.
 * Use `create(UpdateQuestionnaireRequestSchema)` to create a new message.
 */
export const UpdateQuestionnaireRequestSchema: GenMessage<UpdateQuestionnaireRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 27);

/**
 * @generated from message questionnaire.v2.UpdateQuestionnaireResponse
 */
export type UpdateQuestionnaireResponse = Message<"questionnaire.v2.UpdateQuestionnaireResponse"> & {
};

/**
 * Describes the message questionnaire.v2.UpdateQuestionnaireResponse.
 * Use `create(UpdateQuestionnaireResponseSchema)` to create a new message.
 */
export const UpdateQuestionnaireResponseSchema: GenMessage<UpdateQuestionnaireResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 28);

/**
 * @generated from message questionnaire.v2.DeleteQuestionnaireRequest
 */
export type DeleteQuestionnaireRequest = Message<"questionnaire.v2.DeleteQuestionnaireRequest"> & {
  /**
   * @generated from field: string questionnaire_id = 1;
   */
  questionnaireId: string;
};

/**
 * Describes the message questionnaire.v2.DeleteQuestionnaireRequest.
 * Use `create(DeleteQuestionnaireRequestSchema)` to create a new message.
 */
export const DeleteQuestionnaireRequestSchema: GenMessage<DeleteQuestionnaireRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 29);

/**
 * @generated from message questionnaire.v2.DeleteQuestionnaireResponse
 */
export type DeleteQuestionnaireResponse = Message<"questionnaire.v2.DeleteQuestionnaireResponse"> & {
};

/**
 * Describes the message questionnaire.v2.DeleteQuestionnaireResponse.
 * Use `create(DeleteQuestionnaireResponseSchema)` to create a new message.
 */
export const DeleteQuestionnaireResponseSchema: GenMessage<DeleteQuestionnaireResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 30);

/**
 * @generated from message questionnaire.v2.CreateQuestionnaireRequest
 */
export type CreateQuestionnaireRequest = Message<"questionnaire.v2.CreateQuestionnaireRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 4;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: questionnaire.v2.QuestionnaireType type = 5;
   */
  type: QuestionnaireType;

  /**
   * @generated from field: string assessment_id = 6;
   */
  assessmentId: string;

  /**
   * @generated from oneof questionnaire.v2.CreateQuestionnaireRequest.specific_questionnaire_request
   */
  specificQuestionnaireRequest: {
    /**
     * @generated from field: questionnaire.v2.CreateRiskQuestionnaireRequest risk_questionnaire_request = 7;
     */
    value: CreateRiskQuestionnaireRequest;
    case: "riskQuestionnaireRequest";
  } | {
    /**
     * @generated from field: questionnaire.v2.CreateInfoQuestionnaireRequest info_questionnaire_request = 8;
     */
    value: CreateInfoQuestionnaireRequest;
    case: "infoQuestionnaireRequest";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message questionnaire.v2.CreateQuestionnaireRequest.
 * Use `create(CreateQuestionnaireRequestSchema)` to create a new message.
 */
export const CreateQuestionnaireRequestSchema: GenMessage<CreateQuestionnaireRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 31);

/**
 * @generated from message questionnaire.v2.CreateRiskQuestionnaireRequest
 */
export type CreateRiskQuestionnaireRequest = Message<"questionnaire.v2.CreateRiskQuestionnaireRequest"> & {
  /**
   * @generated from field: string ongoing_assessment_id = 1;
   */
  ongoingAssessmentId: string;
};

/**
 * Describes the message questionnaire.v2.CreateRiskQuestionnaireRequest.
 * Use `create(CreateRiskQuestionnaireRequestSchema)` to create a new message.
 */
export const CreateRiskQuestionnaireRequestSchema: GenMessage<CreateRiskQuestionnaireRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 32);

/**
 * @generated from message questionnaire.v2.CreateInfoQuestionnaireRequest
 */
export type CreateInfoQuestionnaireRequest = Message<"questionnaire.v2.CreateInfoQuestionnaireRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * Describes the message questionnaire.v2.CreateInfoQuestionnaireRequest.
 * Use `create(CreateInfoQuestionnaireRequestSchema)` to create a new message.
 */
export const CreateInfoQuestionnaireRequestSchema: GenMessage<CreateInfoQuestionnaireRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 33);

/**
 * @generated from message questionnaire.v2.CreateQuestionnaireResponse
 */
export type CreateQuestionnaireResponse = Message<"questionnaire.v2.CreateQuestionnaireResponse"> & {
  /**
   * @generated from field: string questionnaire_id = 1;
   */
  questionnaireId: string;
};

/**
 * Describes the message questionnaire.v2.CreateQuestionnaireResponse.
 * Use `create(CreateQuestionnaireResponseSchema)` to create a new message.
 */
export const CreateQuestionnaireResponseSchema: GenMessage<CreateQuestionnaireResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 34);

/**
 * @generated from message questionnaire.v2.InviteRecipientsRequest
 */
export type InviteRecipientsRequest = Message<"questionnaire.v2.InviteRecipientsRequest"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;

  /**
   * @generated from field: repeated string emails = 2;
   */
  emails: string[];
};

/**
 * Describes the message questionnaire.v2.InviteRecipientsRequest.
 * Use `create(InviteRecipientsRequestSchema)` to create a new message.
 */
export const InviteRecipientsRequestSchema: GenMessage<InviteRecipientsRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 35);

/**
 * @generated from message questionnaire.v2.InviteRecipientsResponse
 */
export type InviteRecipientsResponse = Message<"questionnaire.v2.InviteRecipientsResponse"> & {
};

/**
 * Describes the message questionnaire.v2.InviteRecipientsResponse.
 * Use `create(InviteRecipientsResponseSchema)` to create a new message.
 */
export const InviteRecipientsResponseSchema: GenMessage<InviteRecipientsResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 36);

/**
 * @generated from message questionnaire.v2.RemoveRecipientsRequest
 */
export type RemoveRecipientsRequest = Message<"questionnaire.v2.RemoveRecipientsRequest"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;

  /**
   * @generated from field: repeated string emails = 2;
   */
  emails: string[];
};

/**
 * Describes the message questionnaire.v2.RemoveRecipientsRequest.
 * Use `create(RemoveRecipientsRequestSchema)` to create a new message.
 */
export const RemoveRecipientsRequestSchema: GenMessage<RemoveRecipientsRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 37);

/**
 * @generated from message questionnaire.v2.RemoveRecipientsResponse
 */
export type RemoveRecipientsResponse = Message<"questionnaire.v2.RemoveRecipientsResponse"> & {
};

/**
 * Describes the message questionnaire.v2.RemoveRecipientsResponse.
 * Use `create(RemoveRecipientsResponseSchema)` to create a new message.
 */
export const RemoveRecipientsResponseSchema: GenMessage<RemoveRecipientsResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 38);

/**
 * @generated from message questionnaire.v2.DeleteManualQuestionnaireActivityRequest
 */
export type DeleteManualQuestionnaireActivityRequest = Message<"questionnaire.v2.DeleteManualQuestionnaireActivityRequest"> & {
  /**
   * @generated from field: string questionnaire_id = 1;
   */
  questionnaireId: string;

  /**
   * @generated from field: string question_id = 2;
   */
  questionId: string;

  /**
   * @generated from field: string activity_id = 3;
   */
  activityId: string;
};

/**
 * Describes the message questionnaire.v2.DeleteManualQuestionnaireActivityRequest.
 * Use `create(DeleteManualQuestionnaireActivityRequestSchema)` to create a new message.
 */
export const DeleteManualQuestionnaireActivityRequestSchema: GenMessage<DeleteManualQuestionnaireActivityRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 39);

/**
 * @generated from message questionnaire.v2.DeleteManualQuestionnaireActivityResponse
 */
export type DeleteManualQuestionnaireActivityResponse = Message<"questionnaire.v2.DeleteManualQuestionnaireActivityResponse"> & {
};

/**
 * Describes the message questionnaire.v2.DeleteManualQuestionnaireActivityResponse.
 * Use `create(DeleteManualQuestionnaireActivityResponseSchema)` to create a new message.
 */
export const DeleteManualQuestionnaireActivityResponseSchema: GenMessage<DeleteManualQuestionnaireActivityResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 40);

/**
 * @generated from message questionnaire.v2.GenerateQuestionnaireStatusReportRequest
 */
export type GenerateQuestionnaireStatusReportRequest = Message<"questionnaire.v2.GenerateQuestionnaireStatusReportRequest"> & {
};

/**
 * Describes the message questionnaire.v2.GenerateQuestionnaireStatusReportRequest.
 * Use `create(GenerateQuestionnaireStatusReportRequestSchema)` to create a new message.
 */
export const GenerateQuestionnaireStatusReportRequestSchema: GenMessage<GenerateQuestionnaireStatusReportRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 41);

/**
 * @generated from message questionnaire.v2.QuestionnaireStatusReportRow
 */
export type QuestionnaireStatusReportRow = Message<"questionnaire.v2.QuestionnaireStatusReportRow"> & {
  /**
   * @generated from field: string company_name = 1;
   */
  companyName: string;

  /**
   * @generated from field: string project_name = 2;
   */
  projectName: string;

  /**
   * @generated from field: string questionnaire_name = 3;
   */
  questionnaireName: string;

  /**
   * @generated from field: questionnaire.common.v1.QuestionnaireStatus status = 4;
   */
  status: QuestionnaireStatus;

  /**
   * @generated from field: int32 answered_questions = 5;
   */
  answeredQuestions: number;

  /**
   * @generated from field: int32 total_questions = 6;
   */
  totalQuestions: number;
};

/**
 * Describes the message questionnaire.v2.QuestionnaireStatusReportRow.
 * Use `create(QuestionnaireStatusReportRowSchema)` to create a new message.
 */
export const QuestionnaireStatusReportRowSchema: GenMessage<QuestionnaireStatusReportRow> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 42);

/**
 * @generated from message questionnaire.v2.GenerateQuestionnaireStatusReportResponse
 */
export type GenerateQuestionnaireStatusReportResponse = Message<"questionnaire.v2.GenerateQuestionnaireStatusReportResponse"> & {
  /**
   * @generated from field: repeated questionnaire.v2.QuestionnaireStatusReportRow rows = 1;
   */
  rows: QuestionnaireStatusReportRow[];
};

/**
 * Describes the message questionnaire.v2.GenerateQuestionnaireStatusReportResponse.
 * Use `create(GenerateQuestionnaireStatusReportResponseSchema)` to create a new message.
 */
export const GenerateQuestionnaireStatusReportResponseSchema: GenMessage<GenerateQuestionnaireStatusReportResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 43);

/**
 * @generated from message questionnaire.v2.SendManualReminderRequest
 */
export type SendManualReminderRequest = Message<"questionnaire.v2.SendManualReminderRequest"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;

  /**
   * @generated from field: repeated string emails = 2;
   */
  emails: string[];
};

/**
 * Describes the message questionnaire.v2.SendManualReminderRequest.
 * Use `create(SendManualReminderRequestSchema)` to create a new message.
 */
export const SendManualReminderRequestSchema: GenMessage<SendManualReminderRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 44);

/**
 * @generated from message questionnaire.v2.SendManualReminderResponse
 */
export type SendManualReminderResponse = Message<"questionnaire.v2.SendManualReminderResponse"> & {
};

/**
 * Describes the message questionnaire.v2.SendManualReminderResponse.
 * Use `create(SendManualReminderResponseSchema)` to create a new message.
 */
export const SendManualReminderResponseSchema: GenMessage<SendManualReminderResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v2_questionnaire, 45);

/**
 * @generated from service questionnaire.v2.QuestionnaireService
 */
export const QuestionnaireService: GenService<{
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.CreateQuestionnaire
   */
  createQuestionnaire: {
    methodKind: "unary";
    input: typeof CreateQuestionnaireRequestSchema;
    output: typeof CreateQuestionnaireResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.GetSmartEvidenceReviewSetting
   */
  getSmartEvidenceReviewSetting: {
    methodKind: "unary";
    input: typeof GetSmartEvidenceReviewSettingRequestSchema;
    output: typeof GetSmartEvidenceReviewSettingResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.SetSmartEvidenceReviewSetting
   */
  setSmartEvidenceReviewSetting: {
    methodKind: "unary";
    input: typeof SetSmartEvidenceReviewSettingRequestSchema;
    output: typeof SetSmartEvidenceReviewSettingResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.GetRiskQuestionnaire
   */
  getRiskQuestionnaire: {
    methodKind: "unary";
    input: typeof GetRiskQuestionnaireRequestSchema;
    output: typeof GetRiskQuestionnaireResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.GetInfoQuestionnaire
   */
  getInfoQuestionnaire: {
    methodKind: "unary";
    input: typeof GetInfoQuestionnaireRequestSchema;
    output: typeof GetInfoQuestionnaireResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.UpdateQuestionnaire
   */
  updateQuestionnaire: {
    methodKind: "unary";
    input: typeof UpdateQuestionnaireRequestSchema;
    output: typeof UpdateQuestionnaireResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.DeleteQuestionnaire
   */
  deleteQuestionnaire: {
    methodKind: "unary";
    input: typeof DeleteQuestionnaireRequestSchema;
    output: typeof DeleteQuestionnaireResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.ListQuestionnaires
   */
  listQuestionnaires: {
    methodKind: "unary";
    input: typeof ListQuestionnairesRequestSchema;
    output: typeof ListQuestionnairesResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.InviteRecipients
   */
  inviteRecipients: {
    methodKind: "unary";
    input: typeof InviteRecipientsRequestSchema;
    output: typeof InviteRecipientsResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.RemoveRecipients
   */
  removeRecipients: {
    methodKind: "unary";
    input: typeof RemoveRecipientsRequestSchema;
    output: typeof RemoveRecipientsResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.SubmitManualQuestionnaire
   */
  submitManualQuestionnaire: {
    methodKind: "unary";
    input: typeof SubmitManualQuestionnaireRequestSchema;
    output: typeof SubmitManualQuestionnaireResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.SubmitRiskQuestionnaireThreadActivity
   */
  submitRiskQuestionnaireThreadActivity: {
    methodKind: "unary";
    input: typeof SubmitRiskQuestionnaireThreadActivityRequestSchema;
    output: typeof SubmitRiskQuestionnaireThreadActivityResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.GetPortalCommentsRoom
   */
  getPortalCommentsRoom: {
    methodKind: "unary";
    input: typeof GetPortalCommentsRoomRequestSchema;
    output: typeof GetPortalCommentsRoomResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.SubmitManualQuestionnaireActivity
   */
  submitManualQuestionnaireActivity: {
    methodKind: "unary";
    input: typeof SubmitManualQuestionnaireActivityRequestSchema;
    output: typeof SubmitManualQuestionnaireActivityResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.DeleteManualQuestionnaireActivity
   */
  deleteManualQuestionnaireActivity: {
    methodKind: "unary";
    input: typeof DeleteManualQuestionnaireActivityRequestSchema;
    output: typeof DeleteManualQuestionnaireActivityResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.UpdateManualQuestion
   */
  updateManualQuestion: {
    methodKind: "unary";
    input: typeof UpdateManualQuestionRequestSchema;
    output: typeof UpdateManualQuestionResponseSchema;
  },
  /**
   * kept for backward compatibility with past questionnaires in Liveblocks with file questions
   *
   * @generated from rpc questionnaire.v2.QuestionnaireService.GetQuestionnaireArtifactPreviewUrl
   */
  getQuestionnaireArtifactPreviewUrl: {
    methodKind: "unary";
    input: typeof GetQuestionnaireArtifactPreviewUrlRequestSchema;
    output: typeof GetQuestionnaireArtifactPreviewUrlResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.SendManualReminder
   */
  sendManualReminder: {
    methodKind: "unary";
    input: typeof SendManualReminderRequestSchema;
    output: typeof SendManualReminderResponseSchema;
  },
  /**
   * Consider removing this — still used in the assessment service for edge cases.
   * Must be resolved before removal.
   *
   * @generated from rpc questionnaire.v2.QuestionnaireService.FinalizeQuestionnaire
   */
  finalizeQuestionnaire: {
    methodKind: "unary";
    input: typeof FinalizeQuestionnaireRequestSchema;
    output: typeof FinalizeQuestionnaireResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v2.QuestionnaireService.GenerateQuestionnaireStatusReport
   */
  generateQuestionnaireStatusReport: {
    methodKind: "unary";
    input: typeof GenerateQuestionnaireStatusReportRequestSchema;
    output: typeof GenerateQuestionnaireStatusReportResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_questionnaire_v2_questionnaire, 0);

